const I = {
  8: "s",
  12: "md",
  16: "lg",
  24: "xl"
}, _ = 28, A = 28, N = 40, D = 32, o = 4;
export {
  A as CHECKBOX_SIZE_WITH_PADDING,
  o as HEADING_MARGIN,
  _ as ICON_SIZE_WITH_PADDING,
  I as PADDING_MAPPING,
  N as THUMBNAIL_SIZE_MEDIUM,
  D as THUMBNAIL_SIZE_SMALL
};
//# sourceMappingURL=index.es765.js.map
